import { render, staticRenderFns } from "./UiDatePickerInline.vue?vue&type=template&id=263d64cd&lang=pug&"
import script from "./UiDatePickerInline.vue?vue&type=script&lang=ts&"
export * from "./UiDatePickerInline.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports